import { render } from "./growth.vue?vue&type=template&id=ccbadfe6&scoped=true"
import script from "./growth.vue?vue&type=script&lang=js"
export * from "./growth.vue?vue&type=script&lang=js"

import "./growth.vue?vue&type=style&index=0&id=ccbadfe6&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbadfe6"]])

export default __exports__